import React, {useState} from 'react';
import '../Sass/AbroadCustomerDataUsageBlock.scss';
import BankPackages from './BankPackages';
import TariffPackage from './TariffPackage';
import NoBankPackages from './NoBankPackages';
import Arrow from '../SVGs/Arrow';
import NoPackages from './NoPackages';
import NoData from './NoData';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import gaParams from '../../../../utilities/analytics/constants';

const UsageCycle = ({thisCycle, currentCycle = false, setActiveLobbyTab, context, currPath, iContent}) => {
  //#region State and state handlers
  const [closed, setClosed] = useState('Closed');

  const handleClosed = () => {
    gaEvent(
      gaParams.ABROAD_DATAUSAGES_PREVIOUSCYCLECLICK.category,
      gaParams.ABROAD_DATAUSAGES_PREVIOUSCYCLECLICK.eventType,
      gaParams.ABROAD_DATAUSAGES_PREVIOUSCYCLECLICK.eventParams
    );
    if (!currentCycle) {
      if (closed == '') {
        setClosed('Closed');
      } else {
        setClosed('');
      }
    }
  };
  //#endregion

  //#region  Data Appending
  const cycleHeadText = currentCycle ? 'מחזור חיוב נוכחי' : 'מחזור חיוב קודם';
  let subHeading = '',
    bankPackages = '',
    closeIndicator = '',
    packageRender = <NoPackages isCurrentCycle={currentCycle} />;

  if (thisCycle != null) {
    if (thisCycle.abroadBankPackages != null || thisCycle.discountTariffPackage != null || thisCycle.overheadTariffPackage != null) {
      if (thisCycle.abroadBankPackages != null) {
        bankPackages = (
          <BankPackages
            cycleStart={thisCycle != null ? thisCycle.cycleStart : ''}
            bankPackages={thisCycle != null ? thisCycle.abroadBankPackages : null}
            isCurrentCycle={currentCycle}
          />
        );
      } else {
        if (currentCycle) {
          bankPackages = <NoBankPackages setActiveLobbyTab={setActiveLobbyTab} context={context} iContent={iContent} currPath={currPath} />;
        }
      }
      packageRender = (
        <div>
          {bankPackages}
          <TariffPackage
            cycleStart={thisCycle != null ? thisCycle.cycleStart : ''}
            thisPackage={thisCycle != null ? thisCycle.discountTariffPackage : null}
            isCurrentCycle={currentCycle}
          />
          <TariffPackage
            cycleStart={thisCycle != null ? thisCycle.cycleStart : ''}
            thisPackage={thisCycle != null ? thisCycle.overheadTariffPackage : null}
            isOverhead={true}
            isCurrentCycle={currentCycle}
          />
        </div>
      );
    } else {
      packageRender = <NoPackages isCurrentCycle={currentCycle} />;
    }

    if (currentCycle) {
      subHeading = thisCycle.cycleStart + ' - היום';
    } else {
      subHeading = thisCycle.cycleStart + ' - ' + thisCycle.cycleEnd;
      closeIndicator = (
        <div className={'CycleCloseIndicator ' + closed}>
          <Arrow />
        </div>
      );
    }
  } else {
    return <NoData />;
  }
  //#endregion
  return (
    <div className='AbroadCustomerDataUsageBlock_UsageCycle'>
      <div className={'CycleHeader ' + (currentCycle ? '' : closed + ' PreviousCycle')} onClick={handleClosed}>
        <div>
          <p className='Heading'>{cycleHeadText}</p>
          <p className='SubHeading'>{subHeading}</p>
        </div>
        {closeIndicator}
      </div>
      <div className={'CycleBody ' + (currentCycle ? '' : closed)}>{packageRender}</div>
    </div>
  );
};

export default UsageCycle;
